// src/components/Layout/Layout.tsx
import React from 'react';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Sidebar/Sidebar';
import './Layout.css';

interface LayoutProps {
    children?: React.ReactNode;
    hideHeader?: boolean;
    onLogout?: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, hideHeader, onLogout }) => (
    <div className="layout">
        {!hideHeader && <Navbar />}
        <Sidebar />
        <div className="main-content">
            {children} {/* This is where your routed components will render */}
        </div>
    </div>
);

export default Layout;